function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:url(#linear-gradient);}.cls-4{clip-path:url(#clip-path-2);}.cls-5{fill:url(#linear-gradient-2);}.cls-6{clip-path:url(#clip-path-3);}.cls-7{fill:url(#linear-gradient-3);}.cls-8{clip-path:url(#clip-path-4);}.cls-9{fill:url(#linear-gradient-4);}.cls-10{clip-path:url(#clip-path-5);}"), React.createElement("clipPath", {
  id: "clip-path",
  transform: "translate(0 0.1)"
}, React.createElement("path", {
  className: "cls-1",
  d: "M425.16,3.6a3.61,3.61,0,1,0,0,7.21h23.76a3.61,3.61,0,1,0,0-7.21Z"
})), React.createElement("linearGradient", {
  id: "linear-gradient",
  y1: 42.08,
  x2: 1,
  y2: 42.08,
  gradientTransform: "matrix(0, 51.75, 51.75, 0, -1740.46, -7.31)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#192344"
}), React.createElement("stop", {
  offset: 0.02,
  stopColor: "#192344"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#364be8"
})), React.createElement("clipPath", {
  id: "clip-path-2",
  transform: "translate(0 0.1)"
}, React.createElement("path", {
  className: "cls-1",
  d: "M449.13,15.21a3.61,3.61,0,1,0,0,7.21h42a3.61,3.61,0,1,0,0-7.21Z"
})), React.createElement("linearGradient", {
  id: "linear-gradient-2",
  y1: 42.08,
  x2: 1,
  y2: 42.08,
  gradientTransform: "matrix(69.06, 0, 0, -69.06, 451.4, 2924.62)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#192344"
}), React.createElement("stop", {
  offset: 0.02,
  stopColor: "#192344"
}), React.createElement("stop", {
  offset: 0.53,
  stopColor: "#364be8"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#0599ff"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#0599ff"
})), React.createElement("clipPath", {
  id: "clip-path-3",
  transform: "translate(0 0.1)"
}, React.createElement("path", {
  className: "cls-1",
  d: "M460.88,0A3.61,3.61,0,0,0,461,7.21h11.21A3.61,3.61,0,0,0,472.23,0Z"
})), React.createElement("linearGradient", {
  id: "linear-gradient-3",
  y1: 42.08,
  y2: 42.08,
  gradientTransform: "matrix(0, 51.75, 51.75, 0, -1710.95, -40.41)",
  xlinkHref: "#linear-gradient"
}), React.createElement("clipPath", {
  id: "clip-path-4",
  transform: "translate(0 0.1)"
}, React.createElement("path", {
  className: "cls-1",
  d: "M507,15.05a3.61,3.61,0,0,0,0,7.21h11.21a3.61,3.61,0,0,0,0-7.21Z"
})), React.createElement("linearGradient", {
  id: "linear-gradient-4",
  y1: 42.08,
  y2: 42.08,
  gradientTransform: "matrix(69.06, 0, 0, -69.06, 451.4, 2924.46)",
  xlinkHref: "#linear-gradient-2"
}), React.createElement("clipPath", {
  id: "clip-path-5",
  transform: "translate(0 0.1)"
}, React.createElement("rect", {
  className: "cls-1",
  width: 521.85,
  height: 42.08
})));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "logo-black");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  className: "cls-2"
}, React.createElement("rect", {
  className: "cls-3",
  x: 433.35,
  y: -8.3,
  width: 7.38,
  height: 31.01,
  transform: "matrix(0.01, -1, 1, 0.01, 427.46, 444.3)"
}));

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  className: "cls-4"
}, React.createElement("rect", {
  className: "cls-5",
  x: 445.48,
  y: 14.93,
  width: 49.31,
  height: 7.78,
  transform: "translate(-0.19 5.54) rotate(-0.66)"
}));

var _ref6 =
/*#__PURE__*/
React.createElement("g", {
  className: "cls-6"
}, React.createElement("rect", {
  className: "cls-7",
  x: 462.9,
  y: -5.62,
  width: 7.31,
  height: 18.45,
  transform: "translate(460.42 470.23) rotate(-89.69)"
}));

var _ref7 =
/*#__PURE__*/
React.createElement("g", {
  className: "cls-8"
}, React.createElement("rect", {
  className: "cls-9",
  x: 503.4,
  y: 14.95,
  width: 18.49,
  height: 7.42,
  transform: "translate(-0.18 6.03) rotate(-0.66)"
}));

var _ref8 =
/*#__PURE__*/
React.createElement("g", {
  className: "cls-10"
}, React.createElement("path", {
  d: "M26,42.08c-14.6,0-26-8.6-26-19.58S11.43,2.92,26,2.92c9.67,0,18.47,4,23,10.29l-3.8,2.7a3.87,3.87,0,0,1-4.76-.26C37,12.73,31.72,10.94,26,10.94c-9.76,0-18,5.29-18,11.56s8.25,11.56,18,11.56c5.69,0,11-1.79,14.4-4.7a3.87,3.87,0,0,1,4.78-.26L49,31.78c-4.5,6.35-13.3,10.3-23,10.3",
  transform: "translate(0 0.1)"
}), React.createElement("path", {
  d: "M359.89,42.08c-14.6,0-26-8.6-26-19.58s11.44-19.58,26-19.58c9.66,0,18.47,4,23,10.29l-3.8,2.7a3.88,3.88,0,0,1-4.77-.26c-3.39-2.92-8.72-4.71-14.4-4.71-9.77,0-18,5.29-18,11.56s8.25,11.56,18,11.56c5.68,0,11-1.79,14.39-4.7a3.87,3.87,0,0,1,4.78-.26l3.8,2.68c-4.5,6.35-13.31,10.3-23,10.3",
  transform: "translate(0 0.1)"
}), React.createElement("path", {
  d: "M66.33,41.74,85,11.5h0v.07h0l17.69,28.61a3.26,3.26,0,0,0,2.78,1.56h7.58L90.64,5.37A3.73,3.73,0,0,0,87.46,3.6H82.3a3.24,3.24,0,0,0-2.76,1.54L56.92,41.74Z",
  transform: "translate(0 0.1)"
}), React.createElement("path", {
  d: "M281.15,41.74,299.84,11.5h0v.07h.05l17.68,28.61a3.26,3.26,0,0,0,2.79,1.56h7.58L305.46,5.37a3.73,3.73,0,0,0-3.18-1.77h-5.16a3.24,3.24,0,0,0-2.76,1.54l-22.62,36.6Z",
  transform: "translate(0 0.1)"
}), React.createElement("path", {
  d: "M132,34.32V7.8a4.2,4.2,0,0,0-4.2-4.2h-4.71v34a4.07,4.07,0,0,0,4.08,4.08h1.06v0H161V38a3.72,3.72,0,0,0-3.72-3.72Z",
  transform: "translate(0 0.1)"
}), React.createElement("path", {
  d: "M180.39,34.32V7.8a4.2,4.2,0,0,0-4.2-4.2h-4.72v34a4.08,4.08,0,0,0,4.08,4.08h1.06v0h32.75V37.58a3.26,3.26,0,0,0-3.27-3.26Z",
  transform: "translate(0 0.1)"
}), React.createElement("path", {
  d: "M261.83,21.15a11.07,11.07,0,0,0,2.09-7.54A11.33,11.33,0,0,0,252.54,3.47H226.19V3.6H220.5V37.48a4.23,4.23,0,0,0,4.24,4.23h1.45v.11H254a11.9,11.9,0,0,0,12-11.45,11.69,11.69,0,0,0-4.2-9.22m-5.08-6.54a3.94,3.94,0,0,1-3,3.82H229.42V10.68h23.4a3.94,3.94,0,0,1,3.93,3.93m-2.41,19.75H229.42V25.88h24.92a4.24,4.24,0,0,1,0,8.48",
  transform: "translate(0 0.1)"
}), React.createElement("path", {
  d: "M435.18,41.74h7.47L428.64,19H406.93V3.6H398v34a4.09,4.09,0,0,0,4.09,4.09h4.82V26.37h16.86l8.43,13.71a3.47,3.47,0,0,0,3,1.66",
  transform: "translate(0 0.1)"
}));

var SvgLogoBlack = function SvgLogoBlack(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 521.93 42.18",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? React.createElement("title", null, title) : null, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogoBlack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-black.491de087.svg";
export { ForwardRef as ReactComponent };